import * as apis from '@/apis/checkeligibility';
import * as actions from '@/actions/checkeligibility';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
  GET_SERVICE_NUMBER_LIST_REQUEST,
  GET_SERVICE_ELIGIBILITY_DETAILS_REQUEST,
  GET_STAFF_PLAN_ELIGIBILITY_REQUEST,
  STAFF_PLAN_RECON_ELIGIBILITY_REQUEST
} from '@/actions/checkeligibility/actionTypes';
import { IFetchEligibilityDetails, IFetchServiceNumberPayload, IStaffPlanEligibility } from './models/types';

export const getAuth = (state) => state.auth;

function* fetchServiceNumbers({ page, size, searchSvcNo }: IFetchServiceNumberPayload) {
  try {
    const auth = yield select(getAuth);
    const result = yield call(
      apis.getServiceNumbers,
      page,
      size,
      auth.currentAccount?.brn,
      auth.userInfo?.email,
      searchSvcNo
    );
    yield put(actions.getServiceNumbers.success(result.data));
  } catch (error) {
    yield put(actions.getServiceNumbers.failure(error));
  }
}

function* fetchServiceEligibilityDetails({ serviceNoList }: IFetchEligibilityDetails) {
  try {
    const auth = yield select(getAuth);
    const result = yield call(
      apis.getServiceEligibilityDetails,
      auth.currentAccount?.brn,
      auth.userInfo?.email,
      serviceNoList
    );
    yield put(actions.getServiceEligibilityDetails.success(result.data));
  } catch (error) {
    yield put(actions.getServiceEligibilityDetails.failure(error));
  }
}

function* getStaffPlanEligibility({ employeeId }: IStaffPlanEligibility) {
  try {
    const result = yield call(
      apis.getStaffPlanEligibility,
      employeeId
    );
    yield put(actions.getStaffPlanEligibility.success(result.data));
  } catch (error) {
    yield put(actions.getStaffPlanEligibility.failure(error));
  }
}


function* staffPlanReconEligibility({ serviceNoList }: IFetchEligibilityDetails) {
  try {
    const result = yield call(
      apis.staffPlanReconEligibility,
      serviceNoList
    );
    yield put(actions.staffPlanReconEligibility.success(result.data));
  } catch (error) {
    yield put(actions.staffPlanReconEligibility.failure(error));
  }
}

export default function* checkeliginilitySagas() {
  yield takeLatest(GET_SERVICE_NUMBER_LIST_REQUEST, fetchServiceNumbers);
  yield takeLatest(GET_SERVICE_ELIGIBILITY_DETAILS_REQUEST, fetchServiceEligibilityDetails);
  yield takeLatest(GET_STAFF_PLAN_ELIGIBILITY_REQUEST, getStaffPlanEligibility);
  yield takeLatest(STAFF_PLAN_RECON_ELIGIBILITY_REQUEST, staffPlanReconEligibility);
}
